<template lang="html">
  <b-container class="product-list" style="max-width:98%">
    <div class="row " v-if="$store.user.type == 'admin'">

      <div class="col-md-12 center-text title" >
        Lista Prodotti
      </div>
      <div class="col-md-12 center-text subtitle" >
        In questa sezione potrai vedere la lista completa dei prodotti
      </div>
      <div class="col-md-12 center-text subtitle" >
        I prodotti sono ordinabili cliccando nelle colonne
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 riga-bottone-aggiungi" style="display:flex">
        <div class="button-container">
          <b-button class="add-button" @click="form={user_id:filters.user_id}" variant="primary">
            Aggiungi un prodotto
          </b-button>
          <b-button class="add-button" @click="filter_active = []" variant="danger">
            Rimuovi tutti i filtri attivi
          </b-button>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row" v-if="$store.user.type == 'admin'">

          <div class="filter-row col-md-5">
            <div class="company-filter">
              <div class="center-text subtitle">
                Campo da filtrare
              </div>
              <b-select v-model="search_field">
                <option v-for="(field, index) in table_fields" :key="index" :value="field.value">{{ field.label }}</option>
              </b-select>
            </div>
          </div>

          <div class="filter-row col-md-2">
            <div class="company-filter">
              <div class="center-text subtitle">
                Operatore
              </div>
              <b-select v-model="search_operator">
                <option v-for="(operator, index) in filter_operators" :key="index" :value="operator.value">{{ operator.label }}</option>
              </b-select>
            </div>
          </div>

          <div class="filter-row col-md-5">
            <div class="company-filter">
              <div class="center-text subtitle">
                Valore
              </div>
              <div class="company-input">
                <b-form-input v-model="search_value"></b-form-input>
                <button class="btn btn-primary" @click="searchUsers"  >Cerca</button>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>



      <div class="table table-responsive table-hover">
        <table class="w-100">
          <thead>
            <tr class="product-table-header">
              <!-- INTESTAZIONE TABELLA -->
              <th></th>
              <th v-for="field in table_fields" :key="field.id" @click="setOrderField(field.value)">{{field.label}}
                <i v-if="current_order_field.name==field.value" v-bind:class="{ 'rotate': (current_order_field.value=='desc')}" class="fas fa-arrow-down sort-icon"></i>
                <i class="fas fa-filter" :class="{ 'filter-active' : filter_computed.hasOwnProperty(field.value) }" @click.stop="setFilter(field.value, field.label)"></i>
              </th>
              <th>Altre caratteristiche</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!products">
              <td colspan="100%">
                Caricamento...
              </td>
            </tr>
            <tr v-else-if="!products.total">
              <td colspan="100%">
                Nessun Prodotto
              </td>
            </tr>

            <!-- CONTENUTO TABELLA -->
            <tr class="pointer" v-for="product in (products || {}).data" :key="product.id" @click="form = _.cloneDeep(product)">

              <td>
                <img v-if="product.images.length" :src="$url(product.images[0].thumb.sm)" style="width:3rem"/>
              </td>
              <td v-text="product.user.company" class="text-uppercase"></td>
              <td v-text="product.name"></td>
              
              <!-- <td>
                <span v-if="product.is_varie" class="text-info">
                  Varie
                </span>
                <span v-else-if="product.product_type && product.product_type.is_std" class="text-success">
                  {{ product.product_type.code }}
                </span>
                <span v-else class="text-warning">Fuori standard</span>
              </td> -->

              <template v-if="product.product_type">
                <td :class="{ 'green': product.product_type.is_std, 'red': !product.product_type.is_std }" v-text="product.product_type.is_std ? 'Standard' : 'Fuori Standard'"></td>
                <td v-text="product.product_type.shape"></td>
                <td v-text="product.product_type && product.product_type.side_a"></td>
                <td v-text="product.product_type && product.product_type.side_b"></td>
                <td v-text="product.product_type.weight_range"></td>
                <td :class="{ 'green': product.product_type.is_bounded, 'red': !product.product_type.is_bounded }" v-text="product.product_type.is_bounded ? 'Perimetrato' : 'Non perimetrato'"></td>
                <!-- <td :class="{ 'green': product.product_type.is_filled, 'red': !product.product_type.is_filled }"></td> -->
                <!-- <td v-text="product.product_type.is_ht"></td> -->
                <!-- <td :class="{ 'green': product.product_type.is_transpallet, 'red': !product.product_type.is_transpallet }"></td> -->
                <!-- <td v-text="product.product_type.slab_count"></td> -->
                <!-- <td v-text="product.product_type.thickness"></td> -->
                <!-- <td v-text="product.product_type.weight"></td> -->
                <!-- <td v-if="product.always_available" class="green"> Sempre disponibile </td>
                <td v-else-if="product.time_to_expiry >= 14 " class="green"> {{parseInt(product.time_to_expiry)}} gg </td>
                <td class="yellow" v-else-if="product.time_to_expiry < 14 && product.time_to_expiry > 7">{{parseInt(product.time_to_expiry)}} gg</td>
                <td class="red" v-else>{{parseInt(product.time_to_expiry)}} gg</td> -->
              </template>
              <template v-else>
                <td v-for="index in 6" :key="index"></td>
              </template>
              <td v-text="product.quantity"></td>
              <td v-if="product.product_type" :class="{ 'green': product.product_type.is_plastic, 'red': !product.product_type.is_plastic }" v-text="product.product_type.is_plastic ? 'Plastica' : 'Non plastica'"></td>
              <td v-else></td>
              <!-- altre caratteristiche -->
              <td v-text="others(product)"></td>
              <!-- COLONNA PULSANTI RECORD -->
              <td class="text-right">
                <b-icon class="text-info ml-2" icon="info" @click.stop="info = _.cloneDeep(product)" v-b-tooltip.hover title="Info"/>
                <b-icon class="text-info ml-2" icon="files" @click.stop="cloneProduct(product)" v-b-tooltip.hover title="Clona"/>
                <b-icon class="text-danger ml-2" icon="trash" @click.stop="deleteProduct(product.id)" v-b-tooltip.hover title="Elimina"/>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <b-pagination v-if="products && products.last_page > 1"
        :total-rows="products.total"
        :per-page="products.per_page"
        first-text="<<"
        prev-text="<"
        next-text=">"
        last-text=">>"
        v-model="page"
        />


    <!-- MODALE AGGIUNGI/MODIFICA PRODOTTO -->
    <b-modal :visible="!!form" @hidden="form = null" hide-footer hide-header size="lg">
      <product-form v-if="form" :form="form" @saved="refreshProducts" @close="form=null"/>
    </b-modal>
    <!-- MODALE INFO PRODOTTO -->
    <b-modal :visible="!!info" @hidden="info = null" hide-footer hide-header size="lg">
      <product-info v-if="info" :info="info" @close="info=null"/>
    </b-modal>
    <!-- MODALE FILTRO PER CAMPO -->
    <b-modal :visible="!!current_field.data" @hidden="current_field.data = null" hide-footer hide-header size="lg">
      <div v-if="current_field.data" class="modal-field-container">
        <h3>{{current_field.label}}</h3>
        <b-select @input="addFieldToFilter()" v-model="selected_field" :class="{'text-uppercase':current_field.field=='company'}">
          <option v-for="(value, index) in current_field.data" :key="index" :value="value">{{ value }}</option>
        </b-select>
      </div>
    </b-modal>

  </b-container>
</template>

<script>
import ProductForm from '@/components/product-form'
import ProductInfo from '@/components/product-info'

export default {
  components: {
    ProductForm,
    ProductInfo
  },

  data() {
    return {
      products: null,
      page: 1,
      form: null,
      info: null,
      users: null,
      search_value: null,
      search_field: null,
      search_operator: null,
      current_field: {
        table_name: null,
        field: null,
        label: null,
        data: null
      },
      selected_field : null,
      filter_active: [],
      filters: {
        user_id: null,
      },
      current_user_data: null,
      current_order_field : {
          name: null,
          value: null
      },
      table_fields: [
        {
          value: 'company',
          label: 'Azienda'
        },
        {
          value: 'name',
          label: 'Nome'
        },
        {
          value: 'is_std',
          label: 'Standard'
        },
        // {
        //   value: 'code',
        //   label: 'Tipologia'
        // },
        {
          value: 'shape',
          label: 'N vie'
        },
        {
          value: 'side_a',
          label: 'Lato corto'
        },
        {
          value: 'side_b',
          label: 'Lato lungo'
        },
        {
          value: 'weight_range',
          label: 'Portata (Kg)'
        },
        {
          value: 'is_bounded',
          label: 'Perimetrato'
        },
        // {
        //   value: 'is_filled',
        //   label: 'Piano pieno'
        // },
        // {
        //   value: 'is_ht',
        //   label: 'Trattamento termico'
        // },
        // {
        //   value: 'is_transpallet',
        //   label: 'Transpallet'
        // },
        {
          value: 'quantity',
          label: 'Quantità'
        },
        {
          value: 'is_plastic',
          label: 'Plastica'
        },
        // {
        //   value: 'slab_count',
        //   label: 'Tavole'
        // },
        // {
        //   value: 'thickness',
        //   label: 'Spessore'
        // },
        // {
        //   value: 'weight',
        //   label: 'Peso (Kg)'
        // },
        // {
        //   value: 'expiry_time',
        //   label: 'Disponibilità'
        // },
        // {
        //   value: 'created_at',
        //   label: 'Creato il'
        // },
      ],
      filter_operators: [
        {label: 'uguale a', value: '='},
        {label: 'maggiore di', value: '>'},
        {label: 'maggiore o uguale', value: '>='},
        {label: 'minore di', value: '<'},
        {label: 'minore o uguale', value: '<='},
        {label: 'inizia con', value: 'like%'},
        {label: 'contiene', value: '%like%'},
      ],
    }
  },

  created() {
    this.refreshProducts()
    if (this.$store.user.type == 'admin') {
      // this.refreshUsers()
      this.refreshPartners()
      //this.get_current_user_data()
    }

  },
  methods: {
    superClone(x){
      return JSON.parse(JSON.stringify(x))
    },
    cloneProduct(p) {
      let form = this.superClone(p)
      delete(form.id)
      if(!p.is_varie){

        if (!form.product_type.is_std) {
          delete(form.product_type_id)
          delete(form.product_type.id)
        }
      }
      this.form = form
    },
    refreshProducts() {
      let params = {
        user_id: this.filters.user_id,
        page: this.page,
        sorted_param: this.current_order_field.name,
        sorted_value: this.current_order_field.value,
        search_value: this.search_value,
        search_field: this.search_field,
        search_operator: this.search_operator,
      }

      this.filter_active.forEach(element => {
        params[element.field] = element.value
      });

      this.$http.get('products-sorted', {
        params
      }).then(res => {
        this.products = res.data
        console.log(res.data)
      })
    },

    refreshUsers() {
      this.$http.get('users').then(res => {
        this.users = res.data
      })
    },

    get_current_user_data(){
      let params = {
        user_id: this.filters.user_id,
      }
      this.$http.get('get_user',
        {params}
      ).then(res => {
        this.current_user_data = res.data
      })
    },

    refreshPartners(){
      console.log("aggiornamento partners")
      let params = {
        userType: "partner",
      }
      this.$http.get('users' , {
        params
      }).then(res => {
        this.users = res.data
      })
    },

    deleteProduct(id) {
      this.$bvModal.msgBoxConfirm('Sei sicuro ?')
        .then(value => {
          if(value){
            this.$http.delete('products/' + id).then(() => {
              this.refreshProducts()
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    searchUsers(){
      this.refreshProducts()
    },
    setOrderField(field){
        if(this.current_order_field.name!=field){
            this.current_order_field.name = field
            this.current_order_field.value = 'asc'
        } else if(this.current_order_field.value=='desc'){
            this.current_order_field.name = null
            this.current_order_field.value = null
        } else {
            this.current_order_field.value = 'desc'
        }
        this.refreshProducts()
    },
    setFilter(field, field_label){
      // se il flitro è già attivo viene disattivato
      if(this.filter_active.some(e => e.field === field )){
        let index = this.filter_active.findIndex((obj => obj.field == field));
        this.filter_active.splice(index,1)
      }else{
        this.current_field.table_name = null
        if(field !== 'name' && field !== 'is_varie' && field !== 'expiry_time' && field !== 'quantity' && field !== 'created_at'){
          if(field == 'company'){
            this.current_field.table_name = 'user'
          }else{
            this.current_field.table_name = 'product_type'
          }
        }
        let params = {
          user_id: this.filters.user_id,
        }
        this.$http.get('products-field', {
          params
        }).then(res => {
          this.current_field.field = field
          this.current_field.label = field_label
          //caso specifico del campo code (i codici fuori standard non devono essere visualizzati, quindi prelevo soli il campo code dei prodotto standard(is_std==true))
          if(this.current_field.field == 'code'){
            res.data = res.data.filter(function (el) {
              if(el.product_type){
                return el.product_type.is_std == true
              }else{
                return null
              }
            });
          }
          // imposto i dati visualizzando solo il campo selezionato
          if(this.current_field.table_name){
            this.current_field.data = [...new Set( res.data.map(obj => obj[this.current_field.table_name] ? obj[this.current_field.table_name][this.current_field.field] : false)) ];
          }else{
            this.current_field.data = [...new Set( res.data.map(obj => obj[this.current_field.field] )) ];
          }

          //caso specifico del campo code, viene aggiunto l'opzione Varie tra i filtri possibili
          if(this.current_field.field == 'code'){
            this.current_field.data.push('Varie')
          }

          this.current_field.data.sort()
        })
      }
    },
    addFieldToFilter(){
      let field = this.current_field.field
      let value = this.selected_field
      this.filter_active.push( { field, value } )
      this.selected_field = null
      this.current_field.data = null
    },
    others(product){
      if (!product.product_type) return ''
      let altre_caratteristiche = ''
      if(product.is_varie){
        altre_caratteristiche += 'Varie, '
      }else if(product.product_type && product.product_type.is_std){
        altre_caratteristiche += product.product_type.code + ', '
      }else{
        altre_caratteristiche += 'Fuori standard, '
      }
      altre_caratteristiche += `Peso (kg): ${product.product_type.weight}, `
      altre_caratteristiche += product.product_type.is_transpallet ? 'Transpallet ' : ''
      altre_caratteristiche += product.product_type.is_filled ? 'Piano pieno' : ''
      return altre_caratteristiche
    }
  },
  watch: {
    page() {
      this.refreshProducts()
    },
    filters: {
      deep: true,
      handler() {
        this.page = 1
        this.refreshProducts()
        this.get_current_user_data()
      }
    },
    products(){

    },
    search_value(){
      this.refreshProducts()
    },
    filter_active(){
      this.refreshProducts()
    }
  },
  computed: {
    filter_computed(){
      return this.filter_active.reduce(function(result, item) {
        result[item.field] = item.value
        return result
      }, {})
    }
  }


}
</script>

<style lang="scss">
.product-list{
  padding-bottom: 30px;
}
.riga-bottone-aggiungi{
  padding-top:40px;
  padding-bottom: 30px;
  width:100%;
}
.table.table-responsive.table-hover{
  padding-bottom:20px;
  min-height:100px;
}
.product-table-header th{
    cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
}
.center-text{
  width: 100%;
  text-align: center;
}
.title{
  font-size:30px;
}
.subtitle{
  font-size:18px;
}
.filter-row{
  display: flex;
  width:100%;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding-top:30px;
  padding-bottom:30px;
}
.company-filter{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction:column;
  width:100%;
  // padding-right:30px;
}
.company-input{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width:100%;
}
.user-filter{
  width:100%;
  padding-left:30px;
}
.button-container{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  width:100%;
  gap: 10px;
}
.add-button{
  font-size:20px;
  padding-left:40px;
  padding-right:40px;
}
.pallino{
  width:20px;
  height:20px;
  background-color:blue;
}
.green{
  background-color:#81bb5d;
  opacity:0.8;
}
.yellow{
  background-color:#fbad5d;
}
.red{
  background-color:#eb5d5d;
  opacity:0.8;
}
.sort-icon{
    transition: all .3s;
    padding-left: 2px;
}
.rotate{
    transform: rotate(180deg);
}
.modal-field-container{
  max-height: 600px;
  overflow: scroll;
}
.filter-active{
  color: #eb5d5d;
}
.text-uppercase{
  text-transform: uppercase;
}
</style>
